//JS to open specific units or lessons
		
$(document).ready(function() {
    
  function getQueryStringParameters() {
    var parameters = {}, hash;
    var q = document.URL.split('?')[1];
    if(q != undefined) {
      q = q.split('&');
      for(var i = 0; i < q.length; i++) {
        hash = q[i].split('=');
        parameters[hash[0]] = hash[1];
      }
    }
    return parameters;
  }

  function isEmpty(obj) {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  function openLesson(unitlesson, scrollTo) {
    //console.log(unitlesson);
    var unit = unitlesson.split('-')[0];
    var lesson = unitlesson.split('-')[1];
    var scroll_to_lesson = true;

    //if unit and lesson exist, trim them
    if (unit !== undefined) unit = unit.trim();
    if (lesson !== undefined) lesson = lesson.trim();

    // console.log('unit is '+unit); console.log('lesson is '+lesson); console.log('#'+'u'+unit+'_btn'); console.log($('#'+'u'+unit+'_btn').length);

    //no unit or invalid unit, then use first unit and lesson
    if (unit === undefined || !$('#'+'u'+unit+'_btn').length) {
      console.log('Was not a valid unit, make a new one');
      unitlesson = '';
      unit = unitlesson.split('-')[0].trim();
      lesson = unitlesson.split('-')[1].trim();
      scroll_to_lesson = false;
    } 

    var unit_button = '#'+'u'+unit+'_btn';
    var unit_panel = '#'+'u'+unit+'_panel';

    //no lesson or invalid lesson, then find first lesson in this unit
    if (lesson === undefined || !$('#'+'u'+unit+'_l'+lesson+'_btn').length) {
      var nearest_lesson_button = $(unit_panel + ' div button:first-child').first();
      var lesson = $(nearest_lesson_button).attr('id').split('_')[1].split('l')[1];
      scroll_to_lesson = false;
    }
    var lesson_button	= '#'+'u'+unit+'_l'+lesson+'_btn';
    var lesson_panel 	= '#'+'u'+unit+'_l'+lesson+'_panel'; 
    var lesson_iframe	= '#'+'u'+unit+'_l'+lesson+'_iframe'; 
    var section 		= $(lesson_panel);

    var iFrameSrc = section.attr('data-src');
    var scrollto_button = scroll_to_lesson ? lesson_button : unit_button;

    if (scrollTo) {
      $('html, body').animate({ scrollTop: $(scrollto_button).offset().top + (-110) }, 'slow');
    }

    /* NC - Dillon requested that when only unit is provided, do not open the first lesson */
    if (scroll_to_lesson) {
      // Load iframe contents
      $(lesson_iframe).attr('src', iFrameSrc);

      // Set the expanded state on the triggering element
      $(lesson_button).attr('aria-expanded', 'true');

      //Show the lesson panel
      $(lesson_panel).removeAttr('hidden');
    }
  }
  
  
  function accordionInit() {
    var parameters = getQueryStringParameters();

    if(isEmpty(parameters) == false) {
      var found = false;
      $.each(parameters, function(key, value) {
        if (key === 'goto') {
          openLesson(value, true);
		  found = true;
        }
      });
      if (found === false) {
        openLesson( first_lesson , false);
      }
    } else { 
      openLesson( first_lesson , false);
    }
  }
  
  accordionInit();
});